const setIsAIFloatButtonShowing = (state, payload) => {
  state.slideGenerator.isAIFloatButtonShowing = payload
}

const setShowAISlideGeneratorModal = (state, payload) => {
  state.slideGenerator.isAISlideGeneratorModalVisible = payload.show
  if (!payload.touchPoint) return
  state.slideGenerator.gaTouchPointWhenOpenAIModal = payload.touchPoint
}

const setIsAIPromptHasInput = (state, payload) => {
  state.slideGenerator.isAIPromptHasInput = payload
}

export default {
  setShowAISlideGeneratorModal,
  setIsAIPromptHasInput,
  setIsAIFloatButtonShowing,
}
